export default {
  init() {
    // JavaScript to be fired on the home page
    // let exchange_slider = $('#lets-exchange').find('.slider');
    // let nice_to_meet_u_slider = $('#nice-to-meet-u').find('.slider');

    // exchange_slider.slick({
    //   arrows: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   dots: true,
    // });

    // nice_to_meet_u_slider.slick({
    //   arrows: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   dots: true,
    // });

    $('.portfolio-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 800,
      cssEase: 'ease-in-out',
      centerMode: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        },
      ]
    });

    var $grid = $('.posts-wrapper').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true,
      transitionDuration: 0,
    });

    $grid.imagesLoaded().progress( function() {
      $grid.masonry('layout');
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js